import { render, staticRenderFns } from "./wxpricedetail.vue?vue&type=template&id=406b724a&scoped=true&"
import script from "./wxpricedetail.vue?vue&type=script&lang=js&"
export * from "./wxpricedetail.vue?vue&type=script&lang=js&"
import style0 from "./wxpricedetail.vue?vue&type=style&index=0&id=406b724a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406b724a",
  null
  
)

export default component.exports